import { Box, List, Button, Typography } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router-dom";
import DrawerComponent from "./Dashboard/Dashboard-Component/DrawerComponent";
import usePathStyles from "./Report/src/Component/Share/usePathStyles";

function RevenuePath() {
  const classes = usePathStyles();
  const history = useHistory();

  return (
    <Box className={classes.container}>
      <DrawerComponent onReport />
      <Typography className={classes.title} variant="h2" align="center">
        Revenue
      </Typography>
      <List>
        {[
          ["All Revenue", "revenue/all"], //"all-revenue",
          ["Member Revenue", "revenue/member"], //"revenue-member",
          ["Walk-in Revenue", "revenue/walk-in"], //"revenue-walk-in",
          ["All Transactions", "revenue/transactions"], //"transaction",
          ["Member's Transactions", "revenue/member's transactions"], //"transaction",
          ["Walk-in's Transactions", "revenue/walk-in's transactions"], //"transaction",
          ["All Void", "revenue/void"],
          //"void",
        ].map((text) => (
          <Box>
            <Button
              className={classes.button}
              variant="outlined"
              onClick={() => {
                history.push({
                  pathname: "/bi/report/" + text[1],
                });
              }}
            >
              {text[0]}
            </Button>
          </Box>
        ))}
      </List>
    </Box>
  );
}

export default RevenuePath;
